import React from 'react';
import { type DocumentElement as DocumentElementType } from '@eaco/forms-core';
import DocumentElement from '../DocumentView/DocumentElement';

interface Props {
  element: DocumentElementType;
}

const Tab: React.FC<Props> = ({ element }) => {
  const children = element.elements || [];
  const tabName = (element.data as { name?: string })?.name || element.name;

  return (
    <div className="space-y-4">
      <div className="text-sm font-medium text-muted-foreground mb-2">
        Tab: {tabName}
      </div>
      {children.length === 0 ? (
        <p className="text-sm text-muted-foreground italic py-4">
          No elements in this tab
        </p>
      ) : (
        children.map((child) => (
          <DocumentElement key={child.id} element={child} />
        ))
      )}
    </div>
  );
};

export default Tab;
